module.exports = __webpack_public_path__ + "img/brillante_3.b10049c1.svg";